import React, { Component } from 'react';

import { Redirect } from 'react-router-dom';

import { StorageHandler } from 'C4';
import { storageKeys } from 'settings';

export default class CheckLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loggedIn: true,
    };
  }

  componentDidMount() {
    let mobile = false;
    const params = new URLSearchParams(window.location.search);
    if (params.get('mobile')) {
      mobile = true;
    }

    if (!mobile) {
      StorageHandler.load(storageKeys.user).then(user =>
        this.setState({ loggedIn: user }));

      StorageHandler.load(storageKeys.accessToken).then((token) => {
        if (!token) {
          this.setState({ loggedIn: false });

          // Remove token from storage
          StorageHandler.remove(storageKeys.accessToken);
          StorageHandler.remove(storageKeys.user);
        }

        if (token) {
          // Get token expiration date
          let accessToken = localStorage.getItem('accessToken');
          if (accessToken) {
            accessToken = JSON.parse(accessToken);
            const expiration = accessToken.expires;
            if (expiration) {
              // Check if token is expired
              const now = new Date();
              const expirationDate = new Date(expiration);
              if (now >= expirationDate) {
                // Token is expired
                this.setState({ loggedIn: false });
                // Remove token from storage
                StorageHandler.remove(storageKeys.accessToken);
                StorageHandler.remove(storageKeys.user);
              }
            }
          }
        }
      });
    }
  }

  render() {
    const { loggedIn } = this.state;
    return <div>{!loggedIn && <Redirect to="/main/off" />}</div>;
  }
}
